import React, { useCallback } from 'react';
import { getIn } from 'formik';

import { TextField } from '../../../text-field';
import { NumberFormatCustom } from './number-format';
import { FieldElementPropTypes } from '../../propTypes';
import { buildTooltipAdornment } from '../tooltip-adornment';

const Numeric = ({
  field: { id, name, label, mode, format, value, onChange: customOnChange, hideErrorMessage, ...props },
  ctx: { handleChange, touched, errors, classes, setFieldTouched, setFieldValue }
}) => {
  const onChange = useCallback(
    (e) => {
      const newValue = e.target.value;
      // Skip no-op updates to prevent infinite render loops (react-number-format
      // fires onValueChange on re-render even when the value hasn't changed)
      if (newValue === value) {
        return;
      }
      handleChange(e);
      setFieldValue(id, newValue);
      setFieldTouched(id, true, false);
      if (customOnChange) {
        customOnChange(newValue);
      }
    },
    [handleChange, setFieldTouched, id, value, customOnChange, setFieldValue]
  );
  const { inputProps, InputProps, noMarginRight, tooltipText, tooltipLabel, ...elemProps } = props || {};
  const tooltipAdornment = buildTooltipAdornment(tooltipText, tooltipLabel);

  return (
    <TextField
      key={id}
      id={id}
      name={name || id}
      label={label}
      value={typeof value === 'number' ? value : undefined}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={hideErrorMessage ? undefined : getIn(touched, name || id) && getIn(errors, name || id)}
      mode={mode}
      fullWidth
      classes={classes[id]}
      style={noMarginRight ? undefined : { marginRight: 8 }}
      {...elemProps}
      InputProps={{
        inputComponent: NumberFormatCustom,
        inputProps: {
          format,
          id
        },
        name: name || id,
        ...(inputProps || {}),
        ...(tooltipAdornment ? { endAdornment: tooltipAdornment } : {}),
        ...(InputProps || {})
      }}
    />
  );
};

Numeric.propTypes = FieldElementPropTypes;

export default Numeric;
